import { WareHouseModel, WareHouseViewModel } from './../../../../viewmodels/ItemViewModel';
import { Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ItemStockReportViewModel } from "src/app/viewmodels/g-item/ItemStockReportViewModel";
import { GetItemStockReport, StockReportTotalViewModel } from "src/app/viewmodels/g-item/StockReportTotalViewModel";
import { NgxSpinnerService } from "ngx-spinner";
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';

@Component({
  selector: "app-warehousestockreport",
  templateUrl: "./warehousestockreport.component.html",
  styleUrls: ["./warehousestockreport.component.scss"],
})
export class WarehousestockreportComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  public stockTotal: GetItemStockReport = new GetItemStockReport();
  public wareHouseVm = new WareHouseModel();
  public vmListItems: any = [];
  p: number = 1;
  public component_Title = "WareHouse Stock Report";
  public wareHouses: Array<any> = [];
  public client: any;
  public user: any;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.getWarehouse();
  }
  getWareHouseReport(id) {

    this.spinner.show();
    this._uow.gReportingService.GetWarehouseStockReportAsync(id).subscribe(
      (res: any) => {
        this.vmListItems = res.stockReportList;
        this.stockTotal = res.result;
        console.log(res);
        this.spinner.hide();
      },
      (err) => {
        console.log(err);
        // this._jq.showSpinner();
        this.spinner.hide();
      }
    );
  }

  getWarehouse() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        debugger
        console.log("warehouses", res);
        this.wareHouses = res.result;
        resolve(res);
      });
    });
  }
  onSelectWareHouse() {
    console.log(this.wareHouseVm.wareHouse);
    this.getWareHouseReport(this.wareHouseVm.wareHouse.id);
  }
}
